import axiosInstance from "@/api/axiosInstance";

export type NotificationResourceType =
  | "INQUIRY"
  | "OFFER"
  | "BOOKING"
  | "BILL"
  | "COMPANY";

export interface NotificationDTO {
  /** The recipient row id, not the notification id — mark-as-read acts on this. */
  id: number;
  category: string;
  type: string;
  title: string;
  body: string | null;
  resourceType: NotificationResourceType | null;
  resourceId: string | null;
  link: string | null;
  createdAt: string;
  readAt: string | null;
}

export interface NotificationPage {
  notifications: NotificationDTO[];
  /** Whether older notifications exist past this page — drives the "load older" button. */
  hasMore: boolean;
}

export class NotificationService {
  /**
   * One page, newest first. Pass the oldest id already held to get the page below it;
   * omit it for the first page.
   */
  public async list(before?: number): Promise<NotificationPage> {
    const response = await axiosInstance.get("/api/v1/notifications", {
      params: before === undefined ? {} : { before },
    });
    return response.data;
  }

  public async unreadCount(): Promise<number> {
    const response = await axiosInstance.get(
      "/api/v1/notifications/unread-count"
    );
    return response.data.count;
  }

  public async markAsRead(id: number): Promise<void> {
    await axiosInstance.patch(`/api/v1/notifications/${id}/read`);
  }

  public async markAllAsRead(): Promise<void> {
    await axiosInstance.patch("/api/v1/notifications/read-all");
  }
}
